import { render, staticRenderFns } from "./pushNotifications.vue?vue&type=template&id=0dc0218b&scoped=true&"
import script from "./pushNotifications.vue?vue&type=script&lang=js&"
export * from "./pushNotifications.vue?vue&type=script&lang=js&"
import style0 from "./pushNotifications.vue?vue&type=style&index=0&id=0dc0218b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0218b",
  null
  
)

export default component.exports